import React, {useState} from 'react';
import cl from './CustomsEtaTemplate.module.css';
import {useGridCellHandleClick} from "../../../../../../components/ui/Grid/Telerik/hooks/useGridCellHandleClick";
import {useTranslation} from "react-i18next";
import CustomsEtaDialog from "../../../actions/CustomsEta/CustomsEtaDialog";
import moment from "moment";
import Icon from "../../../../../../assets/icon/Icon";

const CustomsEtaTemplate = (props: any) => {
    const {handleClick} = useGridCellHandleClick(props.dataItem);
    const {t} = useTranslation();
    const [isDialogShown, setIsDialogShown] = useState<boolean>(false);

    let sId = props.dataItem.sId !== undefined && props.dataItem.sId !== null
        ? props.dataItem.sId
        : '';
    let eta = props.dataItem.eta !== undefined && props.dataItem.eta !== null
        ? props.dataItem.eta
        : '';
    let rId = props.dataItem.rId !== undefined && props.dataItem.rId !== null
        ? props.dataItem.rId
        : '';
    let isArchive = props.dataItem.isArchive !== null && props.dataItem.isArchive !== undefined
        ? Boolean(props.dataItem.isArchive)
        : false;

    let notesUser = props.dataItem["bcNotesUser"] !== undefined && props.dataItem["bcNotesUser"] !== null
        ? props.dataItem["bcNotesUser"]
        : '';
    let notesDate = props.dataItem["bcNotesDate"] !== undefined && props.dataItem["bcNotesDate"] !== null
        ? moment.utc(props.dataItem["bcNotesDate"], 'DD.MM.YY HH:mm').local().format('DD.MM.YYYY HH:mm')
        : '';

    if (isArchive || !sId || sId === '') {
        return (
            <td {...props.tdProps}
                colSpan={1}
                onClick={handleClick}>
                <span className={'default-left-cell default-overflow-cell'}>
                    {eta}
                </span>
            </td>
        )
    }

    return (
        <td {...props.tdProps}
            colSpan={1}>
            <CustomsEtaDialog id={rId}
                              sId={sId}
                              show={isDialogShown}
                              setShow={setIsDialogShown}/>
            <span onClick={handleClick} className={'default-left-cell default-overflow-cell grid-prevent-selection'}>
                <>

                <Icon icon={"faPen"}
                      className={`${cl.icon} ${eta && eta !== '' ? cl.iconWithValue : ''} grid-prevent-selection shipment-grid-edit-customer-eta-btn`}
                      onClick={(ev) => {
                          ev.stopPropagation();

                          setIsDialogShown(prev => !prev);
                      }}/>
                    {eta && eta !== ''
                        ? <span className={`grid-prevent-selection ${cl.text}`} title={notesUser + " " + notesDate}
                                onClick={(ev) => {
                                    ev.stopPropagation();

                                    setIsDialogShown(prev => !prev);
                                }}>
                        {eta}
                    </span>
                        : <span className={`grid-prevent-selection ${cl.addText}`}
                                onClick={(ev) => {
                                    ev.stopPropagation();

                                    setIsDialogShown(prev => !prev);
                                }}>
                        {t("shipment.grid.add-date")}
                    </span>
                    }
                </>
            </span>
        </td>
    );
};

export default CustomsEtaTemplate;
